import { render, staticRenderFns } from "./CategoryCrudModals.vue?vue&type=template&id=78399084&"
import script from "./CategoryCrudModals.vue?vue&type=script&lang=js&"
export * from "./CategoryCrudModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports